"use client";

import { devLabel } from "@/lib/dev-labels";
import { COMBOS, type ComboRecipe } from "./wizards-data";
import styles from "./MagicWandModal.module.css";

/**
 * ComboRecipes — Phase 25-AB Task 14.
 *
 * Mockup source: docs/mockups/magic-wand.html (panel 29-B).
 *
 * 3 preset combos: 완벽 자동 / 썸네일 + 제목 / 트렌드 최적화. Each
 * combo is a button — clicking fires `onRunCombo(combo)` so the
 * parent can queue or execute the wizard chain.
 */

export interface ComboRecipesProps {
	onRunCombo: (combo: ComboRecipe) => void;
}

export function ComboRecipes({ onRunCombo }: ComboRecipesProps) {
	return (
		<div className={styles.rightBlock} {...devLabel("29-B")}>
			<div className={styles.rightTitle}>추천 조합 (Combo)</div>
			<div
				style={{ display: "flex", flexDirection: "column", gap: 5 }}
				data-testid="combo-recipes"
			>
				{COMBOS.map((c) => (
					<button
						key={c.key}
						type="button"
						className={styles.comboCard}
						onClick={() => onRunCombo(c)}
						data-testid={`combo-${c.key}`}
						aria-label={`${c.name} 콤보 실행 (${c.coinLabel})`}
					>
						<div className={styles.comboHead}>
							<div className={styles.comboEmoji} aria-hidden="true">
								◈
							</div>
							{c.name}
						</div>
						<div className={styles.comboTx}>{c.description}</div>
						<div className={styles.comboFoot}>
							<span className={styles.comboSteps}>
								{c.steps} 단계 · {c.estimate}
							</span>
							<span className={styles.comboCost}>{c.coinLabel}</span>
						</div>
					</button>
				))}
			</div>
		</div>
	);
}
